module.exports = __webpack_public_path__ + "img/14.eb55bb96.jpg";